import { VStack } from '@musinsa/mwms-ds'
import { FormProvider, useForm } from 'react-hook-form'
import { useState } from 'react'
import { flushSync } from 'react-dom'
import { GRID_SIZE } from '@/utils/grid/grid'
import { useSearchBasePrices } from '@/services/settlement/settlementPricing/useSettlementPricingQueries'
import { BasePriceListReq } from '@/services/settlement/settlementPricing/types'
import { BasePriceForm } from './BasePriceForm'
import { BasePriceTable } from './BasePriceTable'
import { BasePriceListSchemaType, getInitForm } from '../../schemas/basePriceListSchema'

// 폼 → API 요청. 송장(단위 UI 값 'INVOICE')은 unit_type 이 아니라 charge_base_type 축이라
// chargeBaseType:'INVOICE' 로 분기 전송하고 unitType 은 비운다. PCS/BOX 는 기존대로 unitType 전송. (LOGISPRD-9878, 옵션 B)
const toReq = (form: BasePriceListSchemaType): BasePriceListReq => {
  const isInvoice = form.unitType === 'INVOICE'
  return {
    country: form.country,
    serviceType: form.serviceType,
    unitType: isInvoice ? null : form.unitType,
    chargeBaseType: isInvoice ? 'INVOICE' : null,
    orderType: form.orderType,
  }
}

export function BasePriceTab() {
  const form = useForm<BasePriceListSchemaType>({ defaultValues: getInitForm() })

  const [currentPage, setCurrentPage] = useState(0)
  const [pageSize, setPageSize] = useState(GRID_SIZE.SETTLEMENT)
  const [queryKey, setQueryKey] = useState<BasePriceListSchemaType>(form.getValues())

  const { data, refetch, isFetching } = useSearchBasePrices({
    ...toReq(queryKey),
    page: currentPage,
    size: pageSize,
  })

  const onChangePage = async (page: number) => {
    flushSync(() => setCurrentPage(page))
    await refetch()
  }

  const onChangePageSize = async (size: number) => {
    flushSync(() => {
      setPageSize(size)
      setCurrentPage(0)
    })
    await refetch()
  }

  const handleSearch = async (formData: BasePriceListSchemaType) => {
    flushSync(() => {
      setQueryKey(formData)
      setCurrentPage(0)
    })
    await refetch()
  }

  return (
    <FormProvider {...form}>
      <VStack gap={16} style={{ flex: 1, minHeight: 0 }}>
        <BasePriceForm onSearch={handleSearch} isLoading={isFetching} />
        <div style={{ flex: 1, minHeight: 0, display: 'flex' }}>
          <BasePriceTable
            rowData={data?.items ?? []}
            pageInfo={data?.pageInfo ?? { page: 0, size: 0, totalCount: 0, totalPages: 0 }}
            onChangePage={onChangePage}
            onChangePageSize={onChangePageSize}
            isLoading={isFetching}
          />
        </div>
      </VStack>
    </FormProvider>
  )
}
